import React from 'react';
import {
  Project,
  Title,
  Cards,
  First,
  FirstCard,
  TopCard,
  BottomCard,
  Right,
  Detail,
  LeftSide,
  Circle
} from './styles';

const ProjectsLoading: React.FC = () => {
  return (
    <Project>
      <Title>Projects</Title>
      <Cards>
        <FirstCard>
          <TopCard>
            <Detail>
              <LeftSide>
                <First className='loading-animation' />
                <First className='loading-animation bottom' />
              </LeftSide>
              <Right className='loading-animation'></Right>
            </Detail>
            <First className='loading-animation last-bottom' />
          </TopCard>
          <BottomCard>
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
          </BottomCard>
        </FirstCard>
        <FirstCard>
          <TopCard>
            <Detail>
              <LeftSide>
                <First className='loading-animation' />
                <First className='loading-animation bottom' />
              </LeftSide>
              <Right className='loading-animation'></Right>
            </Detail>
            <First className='loading-animation last-bottom' />
          </TopCard>
          <BottomCard>
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
          </BottomCard>
        </FirstCard>
        <FirstCard>
          <TopCard>
            <Detail>
              <LeftSide>
                <First className='loading-animation' />
                <First className='loading-animation bottom' />
              </LeftSide>
              <Right className='loading-animation'></Right>
            </Detail>
            <First className='loading-animation last-bottom' />
          </TopCard>
          <BottomCard>
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
            <Circle className='loading-animation' />
          </BottomCard>
        </FirstCard>
      </Cards>
    </Project>
  );
};

export default ProjectsLoading;
